import Resource from 'components/Resources/Resource';
import Carousel from 'components/shared/Carousel/Carousel';
import CarouselContent from 'components/shared/Carousel/CarouselContent';
import CarouselPagination from 'components/shared/Carousel/CarouselPagination';
import useCarousel from 'hooks/useCarousel';
import Autoplay from 'embla-carousel-autoplay';
import Link from 'components/shared/Link/Link';
import { NavProps } from 'components/MainNav/types';
import { HEADER_NAV_ID_PREFIX } from 'components/MainNav/utils';
import { OverflowVisibleSettings } from 'types/constants';

export type NavCarouselProps = Omit<NavProps, 'topBarLink' | 'cta' | 'navContent'>;

const NavCarousel = ({
  resourcesLabel,
  resourcesCollection,
  resourcesUrl,
  resourcesInternalPage,
}: NavCarouselProps) => {
  const { current, setApi, scrollTo } = useCarousel();
  const resources = resourcesCollection.items;

  const autoPlayOptions = {
    delay: 4000,
    stopOnInteraction: true,
    stopOnMouseEnter: true,
    rootNode: (emblaRoot: HTMLElement) => emblaRoot.parentElement,
  };

  return (
    <div className="max-w-[315px]">
      <Link
        id={`${HEADER_NAV_ID_PREFIX}_itg_link`}
        internalPage={resourcesInternalPage}
        href={resourcesUrl}
        className="font-sans font-semibold pb-4 text-label-saans hover:text-fern focus:text-fern">
        {resourcesLabel}
      </Link>

      <Carousel
        aria-label="Nav carousel"
        aria-roledescription="Nav carousel"
        className="flex flex-col gap-4"
        setApi={setApi}
        plugins={[Autoplay(autoPlayOptions)]}
        opts={{ align: 'start', slidesToScroll: 1, containScroll: false, loop: true }}>
        <CarouselContent
          overflowVisible={OverflowVisibleSettings.None}
          className="w-full"
          contentClassName="pl-2 -ml-2">
          <div className="flex gap-5">
            {resources.map((resource, index) => {
              return (
                <Resource
                  className="flex-none md:flex-none w-full pb-0.5 mx-3 max-h-min"
                  contentClassName="flex-row [&>div:first-child]:w-[110px] [&>div:first-child]:h-[110px]"
                  {...resource}
                  key={index}
                  index={index}
                  idPrefix={`${HEADER_NAV_ID_PREFIX}_slider`}
                />
              );
            })}
          </div>
        </CarouselContent>
        <CarouselPagination
          total={resources.length}
          current={current}
          onSelect={scrollTo}
          className={'mb-6'}
          isTimed
          timeDuration={autoPlayOptions.delay / 1000}
          idPrefix={HEADER_NAV_ID_PREFIX}
        />
      </Carousel>
    </div>
  );
};

export default NavCarousel;
